import {useContext} from 'react'

import Context from '@s-ui/react-context'
import PanelCardGroup, {panelCardGroupImageSizes} from '@adv-mt/mt-panel-card-group'

const CardBenefits = () => {
  const {domain, i18n} = useContext(Context)
  const config = domain.get('config')
  const APP_KEY_LITERAL = config.get('APP_NAME')
  const URL_STATICS_IMAGES = config.get('URL_STATICS_IMAGES')

  const appraisalTitle = i18n.t('INSTANT_OFFER.LANDING.BENEFITS.APPRAISAL')
  const withoutProceduresTitle = i18n.t('INSTANT_OFFER.LANDING.BENEFITS.WITHOUT_PROCEDURES')
  const sellQuickTitle = i18n.t('INSTANT_OFFER.LANDING.BENEFITS.SELL_QUICK')

  const cards = [
    {
      title: appraisalTitle,
      description: i18n.t('INSTANT_OFFER.LANDING.BENEFITS.APPRAISAL_DESCRIPTION'),
      image: {
        alt: appraisalTitle,
        src: `${URL_STATICS_IMAGES}coches/landing/instant-offer/rocket.svg`
      }
    },
    {
      title: sellQuickTitle,
      description: i18n.t(`INSTANT_OFFER.LANDING.BENEFITS.SELL_QUICK_DESCRIPTION.${APP_KEY_LITERAL}`),
      image: {
        alt: sellQuickTitle,
        src: `${URL_STATICS_IMAGES}coches/landing/instant-offer/handshake.svg`
      }
    },
    {
      title: withoutProceduresTitle,
      description: i18n.t('INSTANT_OFFER.LANDING.BENEFITS.WITHOUT_PROCEDURES_DESCRIPTION'),
      image: {
        alt: withoutProceduresTitle,
        src: `${URL_STATICS_IMAGES}coches/landing/instant-offer/list-board.svg`
      }
    }
  ]

  return (
    <div className="mt-LandingInstantOffer-benefits">
      <PanelCardGroup
        cardImageSize={panelCardGroupImageSizes.s}
        cards={cards}
        title={i18n.t('INSTANT_OFFER.LANDING.BENEFITS.TITLE')}
      />
    </div>
  )
}

CardBenefits.displayName = 'CardBenefits'

export default CardBenefits
